import { assert } from '.';

/**
 * wait for a value change as soon as possible only one time
 * @param {Zepto} $element and input, select or a collection of radio button of checkboxes
 * @param {Fucntion} callback
 */
export const waitForValueChange = ($element, callback) => {
  const off = (eventHandler) => {
    $element.off('change', eventHandler);
  };

  const handler = (event) => {
    off(handler);
    callback(event);
  };

  $element.on('change', handler);

  return () => off(handler);
};

export const slideUpAndRemove = (options) => {
  assert(options && options.$element, '`options.$element` is required');
  const {
    $element,
    duration,
    onComplete,
  } = options;

  return $element.slideUp(duration, {
    withFade: true,
    onComplete: () => {
      $element.remove();
      if (onComplete) {
        onComplete();
      }
    },
  });
};

const addAndSlideDownFactory = (type) => (options) => {
  assert(options && options.$element, '`options.$element` is required');
  assert(options.$parent, '`options.$parent` is required');

  const {
    $parent,
    $element,
    duration,
    onComplete,
  } = options;

  $parent[type]($element);

  return $element.slideDown(duration, {
    onComplete: () => {
      if (onComplete) {
        onComplete();
      }
    },
  });
};

export const appendAndSlideDown = addAndSlideDownFactory('append');
export const prependAndSlideDown = addAndSlideDownFactory('prepend');
